import type { HTMLAttributes, ReactElement } from 'react';

export const ChromeCastIcon = (props: HTMLAttributes<HTMLOrSVGElement>): ReactElement => (
  <svg
    fill='none'
    height='76'
    viewBox='0 0 76 76'
    width='76'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.75 38.1563C13.0962 38.8621 19.0134 41.7064 23.5285 46.2215C28.0436 50.7366 30.8879 56.6538 31.5937 63M6.75 50.8125C9.75279 51.4249 12.5092 52.9068 14.6762 55.0738C16.8432 57.2408 18.3251 59.9972 18.9375 63M6.75 63H6.78125M44.25 66.125H54.25C59.5005 66.125 62.1257 66.125 64.1312 65.1032C65.8952 64.2044 67.3294 62.7702 68.2282 61.0062C69.25 59.0007 69.25 56.3755 69.25 51.125V24.875C69.25 19.6245 69.25 16.9993 68.2282 14.9938C67.3294 13.2298 65.8952 11.7956 64.1312 10.8968C62.1257 9.875 59.5005 9.875 54.25 9.875H21.75C16.4995 9.875 13.8743 9.875 11.8688 10.8968C10.1048 11.7956 8.67063 13.2298 7.77181 14.9938C6.75 16.9993 6.75 19.6245 6.75 24.875V25.5'
      stroke='#3664FF'
    />
  </svg>
);

export const SettingsIcon = (): ReactElement => (
  <svg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='11' cy='11' r='9' stroke='#758599' strokeWidth='2' />
    <path
      d='M11 7V11L13.5 13.5'
      stroke='#758599'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
